/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { useContext, useEffect, useState } from 'react'
import { ItemDrawer } from '../../types/drawer'
import { createBrowserHistory } from 'history'
import {
  DrawerItem as DrawerItemDS,
  ListSubheader,
  Box,
  TIcons,
} from '@yuno/design-system-web'
import loadable from '@loadable/component'
import { ContainerContext } from '../../yuno-dashboard-container-mfe'
import { DrawerSubmenu } from './drawer-submenu'

const PATH_COMPONENTS = {
  insights: loadable(() => import('@yuno/dashboard-insights-mfe')),
  connections: loadable(() => import('@yuno/dashboard-connections-mfe')),
  reconciliations: loadable(
    () => import('@yuno/dashboard-reconciliations-mfe'),
  ),
  payments: loadable(() => import('@yuno/dashboard-payments-mfe')),
  'checkout-builder': loadable(
    () => import('@yuno/dashboard-checkout-builder-mfe'),
  ),
  developers: loadable(() => import('@yuno/dashboard-developers-mfe')),
  //routing: loadable(() => import('@yuno/dashboard-smart-routing-mfe')),
  audit: loadable(() => import('@yuno/dashboard-audit-mfe')),
  home: loadable(() => import('@yuno/dashboard-home-mfe')),
  users: loadable(() => import('@yuno/dashboard-users-mfe')),
}

export type Submenues = {
  link: string
  name: string
  permission: string
}

type DrawerItemProps = {
  item: ItemDrawer
  open: boolean
  onClick?: () => void
  isPrincipalOrganization: boolean
  index: number
  submenues?: Submenues[]
}

const DrawerItem = ({
  item,
  open,
  onClick,
  isPrincipalOrganization,
  index,
  submenues,
}: DrawerItemProps) => {
  const { isLoadingPermissions, permissions, handleToggleDrawer } =
    useContext(ContainerContext)
  const isSubheader = item.type === 'SUB_HEADER'
  const [selected, setSelected] = useState(false)
  const history = createBrowserHistory()

  const exceptions = {
    '/payments': ['/payment-links'],
  }

  const handleSelected = () => {
    const isPathOf =
      history.location.pathname.startsWith(item.pathname) &&
      item.pathname.length > 1

    let isException = false

    if (
      exceptions?.[item.pathname] &&
      exceptions?.[item.pathname]?.includes(location.pathname)
    ) {
      isException = true
    }

    const isEqual = item.pathname === history.location.pathname
    setSelected(isPathOf || isEqual || isException)
  }

  const handleClick = () => {
    if (item.pathname === location.pathname) return

    if (!open && item?.submenues?.length > 0) {
      handleToggleDrawer()
    }

    localStorage.removeItem('breadcrumb')
    if (onClick) {
      onClick()
    }

    if (item.target) {
      window.open(item.pathname, item.target)
      return
    }

    if (item.pathname) {
      ;(window as any).singleSpaNavigate(item.pathname)
    }
  }

  useEffect(() => {
    handleSelected()

    history.listen(() => {
      handleSelected()
    })
  }, [])

  const handleMouseOver = () =>
    PATH_COMPONENTS[item.pathname]?.preload() || null

  return (
    <span onMouseOver={handleMouseOver}>
      {!isSubheader && !(isPrincipalOrganization && index !== 0) && (
        <>
          {!submenues || !open || !permissions.includes(item.permission) ? (
            <DrawerItemDS
              onClick={handleClick.bind(null)}
              text={item.text}
              icon={item.icon as TIcons}
              selected={selected}
              disableTooltip={open}
              disabled={
                isLoadingPermissions
                  ? false
                  : (!permissions.includes(item.permission) &&
                      item.permission !== 'all') ||
                    (isPrincipalOrganization && index !== 0)
              }
            />
          ) : (
            <DrawerSubmenu
              text={item.text}
              onClick={handleClick.bind(null)}
              icon={item.icon as TIcons}
              selected={selected}
              disableTooltip={open}
              submenues={submenues}
            />
          )}
        </>
      )}
      <Box
        sx={{
          marginTop: isSubheader && '40px',
          paddingTop: isSubheader && !open && '48px',
        }}
      >
        {item.type === 'SUB_HEADER' && open && !isPrincipalOrganization && (
          <ListSubheader sx={{ paddingLeft: '32px' }}>
            {item.text}
          </ListSubheader>
        )}
      </Box>
    </span>
  )
}

export default DrawerItem
